/** Remove espaços e padroniza e-mail para armazenamento/comparação. */
function normalizarEmail(email) {
  return String(email || "").trim().toLowerCase().replace(/\s+/g, "");
}

/**
 * Valida formato de e-mail (RFC 5322 simplificado, TLD 2–63 caracteres).
 * @param {string} email
 * @returns {boolean}
 */
function validarEmail(email) {
  const valor = normalizarEmail(email);
  if (!valor || valor.length > 254) return false;

  const regexEmail = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/;
  return regexEmail.test(valor);
}

export { normalizarEmail, validarEmail };
